export function roundCurrency(value: number | null | undefined, decimals = 2): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return 0;
  }
  const factor = 10 ** decimals;
  return Math.round(value * factor + Number.EPSILON) / factor;
}
